module.exports = __webpack_public_path__ + "img/one.6b754d25.png";